import { useQuery } from 'hooks/useCustomQuery';
import { useSelector } from 'react-redux';
import getAllTrunks from '@/API/Trunk/getAllTrunks';

const useGetCompanyTrunks = (setTrunks, specificCompanyId) => {
    const { currentCompany: companyId } = useSelector((state) => {
        return { ...state.navigationLists };
    });
    const { requiredScope: accountScope } = useSelector((state) => state.login);
    return useQuery({
        queryKey: ['trunks', companyId, accountScope],
        queryFn: async () => {
            const data = await getAllTrunks(
                specificCompanyId || companyId,
                accountScope,
            ).then((res) => {
                const allTrunks = res.concat({
                    id: null,
                    name: '-Not Allocated-',
                });
                setTrunks(allTrunks);
                return allTrunks;
            });
            return data;
        },
        refetchOnWindowFocus: false,
        enabled: !!companyId,
        staleTime: 0,
    });
};

export default useGetCompanyTrunks;
